import { UserColumns, UserData, userEntityName } from '@/backend/features/authentication/shared';
import { useTranslation } from '@/ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
import { useUserFormConfig } from './useUserFormConfig';

export function useHandleAddUser(reload: () => void) {
    const { t } = useTranslation();
    const userFormConfig = useUserFormConfig('add');
    const userStorage = useStorageClient<UserData, UserColumns>(userEntityName);
    return React.useCallback(() => {
        showFormDialog({
            title: t('addUser'),
            config: userFormConfig,
            data: {
                firstName: '',
                lastName: '',
                permissions: [],
            },
            onSubmit: (data) => {
                return userStorage
                    .post({ action: 'create', data: data })
                    .then(() => reload())
                    .catch((error) => {
                        handleErrorDialog(error);
                        throw error;
                    });
            },
        });
    }, [reload, t, userFormConfig, userStorage]);
}
